module.exports = __webpack_public_path__ + "img/news_3_2.6a28f2da.jpg";